import Link from "next/link";

export default function Footer() {
  return (
    <footer className="bg-foreground text-background py-12">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-xl font-medium mb-4">OnlyLife</h4>
            <p className="text-sm text-background/80 mb-6">
              Telehealth for a healthy, handsome you. Get treatments for ED,
              hair loss, skin care, and more.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/onlylife.pro"
                className="text-background/80 hover:text-background transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Instagram</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>
              <a
                href="https://x.com/onlylifepro"
                className="text-background/80 hover:text-background transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Twitter</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/onlylifepro"
                className="text-background/80 hover:text-background transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">LinkedIn</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-linkedin"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z" />
                </svg>
              </a>
              <a
                href="https://www.facebook.com/pro.onlylife"
                className="text-background/80 hover:text-background transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Facebook</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a
                href="https://www.medium.com/@onlylife.pro"
                className="text-background/80 hover:text-background transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="sr-only">Medium</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-medium"
                  viewBox="0 0 16 16"
                >
                  <path d="M9.025 8c0 2.485-2.02 4.5-4.513 4.5A4.506 4.506 0 0 1 0 8c0-2.486 2.02-4.5 4.512-4.5A4.506 4.506 0 0 1 9.025 8m4.95 0c0 2.34-1.01 4.236-2.256 4.236S9.463 10.339 9.463 8c0-2.34 1.01-4.236 2.256-4.236S13.975 5.661 13.975 8M16 8c0 2.096-.355 3.795-.794 3.795-.438 0-.793-1.7-.793-3.795 0-2.096.355-3.795.794-3.795.438 0 .793 1.699.793 3.795" />
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h5 className="text-lg font-medium mb-4">Products</h5>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Weight Loss
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Better Sex
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Better Sleep
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Gut Health
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Hair Regrowth
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Skin Care
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Mental Health
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-medium mb-4">Resources</h5>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/bmi-calculator"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  BMI Calculator
                </Link>
              </li>
              <li>
                <Link
                  href="/blog"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  href="/affiliate"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Affiliate Marketing
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Weight Loss Guide
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Conditions
                </Link>
              </li>
              <li>
                <Link
                  href="/faq"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h5 className="text-lg font-medium mb-4">Legal</h5>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/terms"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  href="/coming-soon"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Important Safety Information
                </Link>
              </li>
              <li>
                <Link
                  href="/contact-us"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Contact us
                </Link>
              </li>
              <li>
                <Link
                  href="/about-us"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  About us
                </Link>
              </li>
              <li>
                <Link
                  href="/sitemap.xml"
                  className="text-background/80 hover:text-background transition-colors"
                >
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/20 mt-12 pt-8 text-sm text-background/70">
          <p>
            © {new Date().getFullYear()} <a href="https://www.shns.in">Shetty Hospitality & Software Services</a>
            LLP, Inc. All rights reserved.
          </p>
          <p className="mt-2">
            OnlyLife is not affiliated with and does not endorse any third party
            products or services mentioned on this website.
          </p>
        </div>
      </div>
    </footer>
  );
}
